




import Vue from 'vue'
import { MetaInfo } from 'vue-meta'
import ArticleListPage from '~/components/organisms/LandingPage/article/List/index.vue'
import { META_ARTICLE } from '~/constants/article'
import { MainGlobalEvents } from '~/constants/pages/main-global-events'
import getSeoHeader from '~/utils/generator/get-seo-header'

export default Vue.extend({
  components: {
    ArticleListPage,
  },
  layout: 'MainLayout',
  auth: false,
  head(): MetaInfo {
    return getSeoHeader({
      title: META_ARTICLE.title,
      description: META_ARTICLE.description,
      path: 'artikel',
      domain: this.$nuxt.context.$config.cookie.domain,
    })
  },
  mounted() {
    this.$nuxt.$emit(MainGlobalEvents.HEADER_CONFIG, { isWhite: true, showArticleNavbar: true })
  },
})
